import useAuth from "./useAuth";
import {Route, Redirect} from 'react-router-dom';
import {routes} from "./routes/routes";

function PrivateRoute({children, ...rest}) {
    const auth = useAuth();
    return (
        <Route
            {...rest}
            render={({location}) =>
                auth.user ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: routes.login,
                            state: {from: location}
                        }}
                    />
                )
            }
        />
    );
}

export default PrivateRoute;